'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixHelpBox = exports.fixNav = undefined;

require('scrolltofixed');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fixNav = exports.fixNav = function fixNav() {
  var offset = $('.header-main').outerHeight();

  $(_Dom2.default.faqNav).scrollToFixed({ marginTop: offset, zIndex: 6 });
};

var fixHelpBox = exports.fixHelpBox = function fixHelpBox() {
  var offset = $('.header-main').outerHeight() + 60;

  $(_Dom2.default.faqHelpBox).scrollToFixed({
    zIndex: 5,
    marginTop: offset,
    limit: function limit() {
      return $('.global-footer').offset().top - 175;
    }
  });
};